import { render, staticRenderFns } from "./UserProfileImage.vue?vue&type=template&id=16e8db86&scoped=true"
import script from "./UserProfileImage.vue?vue&type=script&lang=js"
export * from "./UserProfileImage.vue?vue&type=script&lang=js"
import style0 from "./UserProfileImage.vue?vue&type=style&index=0&id=16e8db86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e8db86",
  null
  
)

export default component.exports